module.exports = __webpack_public_path__ + "static/media/heart45.587d16ef.svg";